import { render, staticRenderFns } from "./DocPopover.vue?vue&type=template&id=28199b24&scoped=true&"
import script from "./DocPopover.vue?vue&type=script&lang=js&"
export * from "./DocPopover.vue?vue&type=script&lang=js&"
import style0 from "./DocPopover.vue?vue&type=style&index=0&id=28199b24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28199b24",
  null
  
)

export default component.exports